$(document).ready(function () {
    console.log("ready!");

    // 選中menu，去到對應的section
    $('#navbar-nav').onePageNav();
    $('#navbar-nav-phone').onePageNav(); 

    // 點擊手機menu，切換menu的icon
    $(".menu-toggler").click(function(){
        $(".menu-custom").slideToggle(function(){
            console.log($(".menu-custom").css('display'));
            if ($(".menu-custom").css('display') == 'block') {
                $('.navbar-light .navbar-toggler-icon').css('backgroundImage', 'url("assets/img/final/m_menu_close.png")');
            } else {
                $('.navbar-light .navbar-toggler-icon').css('backgroundImage', 'url("assets/img/final/m_menu_open.png")');
            }
        });
    });
    
    // 選中menu的item,隱藏menu,並切換menu的icon
    $(".menu-link").click(function() {
        $(".menu-custom").hide();
        $('.navbar-light .navbar-toggler-icon').css('backgroundImage', 'url("assets/img/final/m_menu_open.png")');
    })

    $('#toTop').click(function (e) { // e =jQuery.fn.event
        var preElement = $('#navbar-nav .nav-item.current').prev().children('a').attr('href');
        scrollAction(preElement);
        console.log($('#navbar-nav .nav-item.current').prev().children('a').attr('href'));

    });
    $('#toFooter').click(function (e) { // e =jQuery.fn.event
        var nextElement = $('#navbar-nav .nav-item.current').next().children('a').attr('href');
        scrollAction(nextElement);
        console.log($('#navbar-nav .nav-item.current').next().children('a').attr('href'));
    });

    function scrollAction(id) {
        var scroll_offset = $(id).offset().top;
        $("body,html").animate({
            scrollTop: scroll_offset
        }, 800);
    }


    // 手機的動畫
    var controller = new ScrollMagic.Controller();
    // Tell Payer Your Identifier start
    var IdentifierTl = new TimelineMax();
    IdentifierTl
        .staggerFromTo('.identifier-content .payer-and-payee .message', 0.5, 
            {autoAlpha: 0}, 
            {autoAlpha: 1, ease:Power0.easeNone}
            )
        .staggerFromTo('.identifier-content .payer-and-payee .message .message-wrap .fps-id', 0.5, 
            {autoAlpha: 0}, 
            {autoAlpha: 1, ease:Power0.easeNone}
            )
        .staggerFromTo('.identifier-content .payer-and-payee .message .message-wrap .slash1', 0.5, 
            {autoAlpha: 0}, 
            {autoAlpha: 1, ease:Power0.easeNone}
            )
        .staggerFromTo('.identifier-content .payer-and-payee .message .message-wrap .phone', 0.5, 
            {autoAlpha: 0}, 
            {autoAlpha: 1, ease:Power0.easeNone}
            )
        .staggerFromTo('.identifier-content .payer-and-payee .message .message-wrap .slash2', 0.5, 
            {autoAlpha: 0}, 
            {autoAlpha: 1, ease:Power0.easeNone}
            )
        .staggerFromTo('.identifier-content .payer-and-payee .message .message-wrap .email', 0.5, 
            {autoAlpha: 0}, 
            {autoAlpha: 1, ease:Power0.easeNone}
            )
        .staggerFromTo('.identifier-content .rectangle .first-line', 0.4, 
            {autoAlpha: 0, x: 20}, 
            { x: 0, autoAlpha: 1, ease:Power0.easeNone}
            )
        .staggerFromTo('.identifier-content .rectangle .second-line', 0.5, 
            {height: 0}, 
            {height: '23rem', ease:Power0.easeNone}
            )
        ;
    var IdentifierScene = new ScrollMagic.Scene({
        triggerElement: '.identifier-content .payer-and-payee',
        reverse: false
    })
    .setTween(IdentifierTl)
    .addTo(controller);
    // Tell Payer Your Identifier end


    // Transfer Instantly start
    var instantlyTl = new TimelineMax();
    instantlyTl
        .staggerFromTo('.transfer-instantly-content .dollar-content .line', .4, 
            {autoAlpha: 0, y: -20}, 
            {autoAlpha: 1, y: 30, ease:Power0.easeNone}
            )
        .staggerFromTo('.transfer-instantly-content .dollar-content .dollar-wrap', 1, 
            {autoAlpha: 0, y: -20}, 
            {autoAlpha: 1, y: 90, 'z-index': -1, repeat: -1, ease:Power0.easeNone}
            )
        ;
    var instantlyScene = new ScrollMagic.Scene({
        triggerElement: '.transfer-instantly-content',
        reverse: false
    })
    .setTween(instantlyTl)
    .addTo(controller);

    var waitingTl = new TimelineMax();
    waitingTl
        .staggerFromTo('.waiting-for-transfer-content .computer-wrap .computer-content .arrow', 1, 
            {autoAlpha: 0, x: '-3.25rem'}, 
            {autoAlpha: 1, x: '3.25rem', ease:Power0.easeNone}
            )
        .staggerFromTo('.receive-transfer-content .dollar-content .line', .2, 
            {autoAlpha: 0, y: -20}, 
            {autoAlpha: 1, y: 20, ease:Power0.easeNone}
            )
        .staggerFromTo('.receive-transfer-content .dollar-content .dollar-wrap', 1, 
            {autoAlpha: 0, y: -20}, 
            {autoAlpha: 1, y: 200, repeat: -1, ease:Power0.easeNone}
            )
        ;
    var waitScene = new ScrollMagic.Scene({
        triggerElement: '.waiting-for-transfer-content .computer-wrap',
        reverse: false
    })
    .setTween(waitingTl)
    .addTo(controller);


    // Get Payee Identifier start
    var getPayeeIdentifierTl = new TimelineMax();
    getPayeeIdentifierTl
        .staggerFromTo('.get-payee-identifier-content .payer-and-payee .message', 0.5, 
            {autoAlpha: 0}, 
            {autoAlpha: 1, ease:Power0.easeNone}
            )
        .staggerFromTo('.get-payee-identifier-content .payer-and-payee .message .message-wrap .fps-id', 0.5, 
            {autoAlpha: 0}, 
            {autoAlpha: 1, ease:Power0.easeNone}
            )
        .staggerFromTo('.get-payee-identifier-content .payer-and-payee .message .message-wrap .slash1', 0.5, 
            {autoAlpha: 0}, 
            {autoAlpha: 1, ease:Power0.easeNone}
            )
        .staggerFromTo('.get-payee-identifier-content .payer-and-payee .message .message-wrap .phone', 0.5, 
            {autoAlpha: 0}, 
            {autoAlpha: 1, ease:Power0.easeNone}
            )
        .staggerFromTo('.get-payee-identifier-content .payer-and-payee .message .message-wrap .slash2', 0.5, 
            {autoAlpha: 0}, 
            {autoAlpha: 1, ease:Power0.easeNone}
            )
        .staggerFromTo('.get-payee-identifier-content .payer-and-payee .message .message-wrap .email', 0.5, 
            {autoAlpha: 0}, 
            {autoAlpha: 1, ease:Power0.easeNone}
            )
        .staggerFromTo('.get-payee-identifier-content .rectangle .first-line', 0.4, 
            {autoAlpha: 0, x: 20}, 
            { x: 0, autoAlpha: 1, ease:Power0.easeNone}
            )
        .staggerFromTo('.get-payee-identifier-content .rectangle .second-line', 0.5, 
            {height: 0}, 
            {height: '15.5625rem', ease:Power0.easeNone}
            )
        ;
    var getPayeeIdentifierScene = new ScrollMagic.Scene({
        triggerElement: '.get-payee-identifier-content .payer-and-payee',
        reverse: false
    })
    .setTween(getPayeeIdentifierTl)
    .addTo(controller);


    // PC端的動畫
    if (!Modernizr.touch) {
       
    	// Init ScrollMagic

        var addressMsgTl = new TimelineMax();
        addressMsgTl
            .staggerFromTo('.setup-addressing-content .address-msg .phone-num', 0.4, 
                {autoAlpha: 0, x: 10}, 
                { x: -20, autoAlpha: 1, ease:Power0.easeNone}
                )
            .staggerFromTo('.setup-addressing-content .address-msg .lines .line-one', 0.7, 
                {autoAlpha: 0}, 
                {autoAlpha: 1, ease:Power0.easeNone}
                )
            .staggerFromTo('.setup-addressing-content .address-msg .lines .line-two', 0.7, 
                {autoAlpha: 0}, 
                {autoAlpha: 1, ease:Power0.easeNone}
                )
            .staggerFromTo('.setup-addressing-content .address-msg .lines .line-three', 0.7, 
                {autoAlpha: 0}, 
                {autoAlpha: 1, ease:Power0.easeNone}
                )
            .staggerFromTo('.setup-addressing-content .bold-line', 1, 
                {height: 0}, 
                {height: '30.625rem', ease:Power0.easeNone}
                )
            ;
        var addressMsgScene = new ScrollMagic.Scene({
            triggerElement: '.address-msg',
            reverse: false
        })
        // .setClassToggle('.address-msg', 'fade-in')
        .setTween(addressMsgTl)
        .addTo(controller);

        var phoneTween = TweenMax.fromTo(".setup-addressing-content .address-msg .phone-group .phone", 1,
                    {y: -10},
                    {y: 10, repeat: -1, yoyo: true, ease: Linear.easeNone}
                );
        var phoneScene = new ScrollMagic.Scene({triggerElement: ".address-msg", reverse: false})
                .setTween(phoneTween)
                .addTo(controller);

        var emailTween = TweenMax.fromTo(".setup-addressing-content .address-msg .email-group .email", 1,
                    {y: -10},
                    {y: 10, repeat: -1, yoyo: true, ease: Linear.easeNone}
                );
        var emailScene = new ScrollMagic.Scene({triggerElement: ".address-msg", reverse: false})
                .setTween(emailTween)
                .addTo(controller);
        var idTween = TweenMax.fromTo(".setup-addressing-content .address-msg .id-group .id", 1,
                    {y: -10},
                    {y: 10, repeat: -1, yoyo: true, ease: Linear.easeNone}
                );
        var idScene = new ScrollMagic.Scene({triggerElement: ".address-msg", reverse: false})
                .setTween(idTween)
                .addTo(controller);



        // parallax scene

        var parallaxMacTl = new TimelineMax();
        parallaxMacTl
            .to('.faster-payment-system-content .mac', 1, {y: '-35%', ease:Power0.easeNone}, 0)
            .to('.faster-payment-system-content .phone', 1, {y: '-65%', ease:Power0.easeNone}, 0)
            .to('.faster-payment-system-content .pen', 1, {y: '-55%', ease:Power0.easeNone}, 0)
            ;

        var slideParallaxMacScene = new ScrollMagic.Scene({
            triggerElement: '.faster-payment-system-content',
            triggerHook: 0,
            duration: '100%'
        })
        .setTween(parallaxMacTl)
        .addTo(controller);



        var parallaxfront1Tl = new TimelineMax();
        parallaxfront1Tl
            .to('.receiving-money-content .front-pic', 2, {y: '30%', ease:Power0.easeNone}, 0)
            ;
        var slideParallaxFront1Scene = new ScrollMagic.Scene({
            triggerElement: '.receiving-money-content',
            triggerHook: 0,
            duration: '100%'
        })
        .setTween(parallaxfront1Tl)
        .addTo(controller);




        var slideLeftTl = new TimelineMax();
        slideLeftTl
            .from('.receiving-money-content .left', 0.6, {x: '-100%', ease:Power0.easeNone}, 0)
            .from('.receiving-money-content .left .main-description', 0.8, {x: '-100%', ease:Power0.easeNone}, 0)
            ;
        var slideLeftScene = new ScrollMagic.Scene({
            triggerElement: '.receiving-money-content',
            triggerHook: 0.5,
            reverse: false
        })
        .setTween(slideLeftTl)
        .addTo(controller);


        

    // Waiting for Transfer start
        var computerContentTween = TweenMax.fromTo(".waiting-for-transfer-content .computer-wrap .computer-content", 1,
                {y: -10},
                {y: 10, repeat: -1, yoyo: true, ease: Linear.easeNone}
            );
        var computerContentScene = new ScrollMagic.Scene({triggerElement: ".waiting-for-transfer-content .computer-wrap", reverse: false})
                .setTween(computerContentTween)
                .addTo(controller);


        var waiting1Tl = new TimelineMax();
        waiting1Tl
            .staggerFromTo('.receive-transfer-content .computer-wrap .computer-content .result', 2.5, 
                {autoAlpha: 0, scale: 0}, 
                {autoAlpha: 1, scale: 1, ease:Power0.easeNone}
                )
            .staggerFromTo('.receive-transfer-content .computer-wrap .computer-content', 2.5, 
                {y: -10},
                {y: 10, repeat: -1, yoyo: true, ease: Linear.easeNone}
                )
            ;
        var wait1Scene = new ScrollMagic.Scene({
            triggerElement: '.waiting-for-transfer-content .computer-wrap',
            reverse: false
        })
        .setTween(waiting1Tl)
        .addTo(controller);

        // Sending Money Start
        var parallaxfront2Tl = new TimelineMax();
        parallaxfront2Tl
            .to('.sending-money-content .front-pic', 2, {y: '30%', ease:Power0.easeNone}, 0)
            ;
        var slideParallaxFront1Scene = new ScrollMagic.Scene({
            triggerElement: '.sending-money-content',
            triggerHook: 0,
            duration: '100%'
        })
        .setTween(parallaxfront2Tl)
        .addTo(controller);




        var sendingMoneyLeftTl = new TimelineMax();
        sendingMoneyLeftTl
            .from('.sending-money-content .left', 0.6, {x: '-100%', ease:Power0.easeNone})
            .from('.sending-money-content .left .main-description', 0.8, {x: '-100%', ease:Power0.easeNone})
            ;
        var sendingMoneyLeftScene = new ScrollMagic.Scene({
            triggerElement: '.sending-money-content',
            triggerHook: 0.5,
            reverse: false
        })
        .setTween(sendingMoneyLeftTl)
        .addTo(controller);


        
        // Tell Payer Your Identifier end


        // Transfer to Payee Start
        var womanTween = TweenMax.fromTo(".transfer-to-payee-content .transfer-person .woman-o", 1,
            {y: -10},
            {y: 10, repeat: -1, yoyo: true, ease: Linear.easeNone}
        );
        var womanScene = new ScrollMagic.Scene({
            triggerElement: ".transfer-to-payee-content .transfer-person", 
            reverse: false
        })
        .setClassToggle('.transfer-to-payee-content .transfer-person .plane-group', 'arrow')
        .setTween(womanTween)
        .addTo(controller);

        var manTween = TweenMax.fromTo(".transfer-to-payee-content .transfer-person .man", 1,
        {y: -10},
        {y: 10, repeat: -1, yoyo: true, ease: Linear.easeNone}
        );
        var manScene = new ScrollMagic.Scene({
            triggerElement: ".transfer-to-payee-content .transfer-person", 
            reverse: false
        })
        .setTween(manTween)
        .addTo(controller);

        var transferToPayeePhoneTween = TweenMax.fromTo(".transfer-to-payee-content .transfer-tool .phone-group .phone", 1,
                {y: -10},
                {y: 10, repeat: -1, yoyo: true, ease: Linear.easeNone}
            );
        var transferToPayeePhoneScene = new ScrollMagic.Scene({
            triggerElement: ".transfer-to-payee-content .transfer-person", 
            reverse: false
        })
        .setTween(transferToPayeePhoneTween)
        .addTo(controller);

        var transferToPayeeEmailTween = TweenMax.fromTo(".transfer-to-payee-content .transfer-tool .email-group .email", 1,
                    {y: -10},
                    {y: 10, repeat: -1, yoyo: true, ease: Linear.easeNone}
                );
        var transferToPayeeEmailScene = new ScrollMagic.Scene({
            triggerElement: ".transfer-to-payee-content .transfer-person", 
            reverse: false
        })
        .setTween(transferToPayeeEmailTween)
        .addTo(controller);

        var transferToPayeeIdTween = TweenMax.fromTo(".transfer-to-payee-content .transfer-tool .id-group .id", 1,
                    {y: -10},
                    {y: 10, repeat: -1, yoyo: true, ease: Linear.easeNone}
                );
        var transferToPayeeIdScene = new ScrollMagic.Scene({
            triggerElement: ".transfer-to-payee-content .transfer-person", 
            reverse: false
        })
        .setTween(transferToPayeeIdTween)
        .addTo(controller);



        var instantly1Tl = new TimelineMax();
        instantly1Tl
            .staggerFromTo('.transfer-instantly-content .computer-wrap .computer-content .result', .8, 
                {autoAlpha: 0, scale: 0}, 
                {autoAlpha: 1, scale: 1, ease:Power0.easeNone}
                )
            .staggerFromTo('.transfer-instantly-content .computer-wrap .computer-content', .8, 
                {y: -10},
                {y: 10, repeat: -1, yoyo: true, ease: Linear.easeNone}
                )
            ;
        var instantly1Scene = new ScrollMagic.Scene({
            triggerElement: '.transfer-instantly-content',
            reverse: false
        })
        .setTween(instantly1Tl)
        .addTo(controller);
    }

    AOS.init();
});